import React from 'react';
import Topbar from '../components/Topbar';
import ProductIcon from '../components/ProductIcon';
import EmptyState from '../components/EmptyState';
import { useApp } from '../context/AppContext';

const StockStatus = ({ onDeposit }) => {
  const { products } = useApp();
  const totalStock = products.reduce((s, p) => s + (p.stock || 0), 0);

  const status = (p) => {
    const s = p.stock || 0;
    if (s <= 0) return { label: 'OUT_OF_STOCK', color: 'text-[#ef4444]' };
    if (s <= 3) return { label: 'LOW_STOCK', color: 'text-[#f59e0b]' };
    return { label: 'IN_STOCK', color: 'text-[#22c55e]' };
  };

  return (
    <div>
      <Topbar count={totalStock} title="STOCK STATUS" subtitleUnit="Units" onDeposit={onDeposit} />
      <div className="px-8 py-6">
        {products.length === 0 ? (
          <EmptyState variant="coming-soon" title="INVENTORY INITIALIZING" subtitle="Stock feed will appear here once products are added." />
        ) : (
        <div className="border border-[#151515] rounded-md overflow-hidden font-mono">
          <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr] px-4 py-3 text-[10px] tracking-[0.25em] text-[#5a5a5a] border-b border-[#151515] bg-[#080808]">
            <div>PRODUCT</div>
            <div>CATEGORY</div>
            <div>USDT</div>
            <div>INR</div>
            <div className="text-right">STATUS</div>
          </div>
          {products.map((p) => {
            const s = status(p);
            return (
              <div key={p.id} className="grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr] px-4 py-3 text-[12px] border-b border-[#0f0f0f] last:border-0 items-center hover:bg-[#0d0d0d] transition-colors">
                <div className="flex items-center gap-2.5 text-[#e6e6e6] pr-3 truncate">
                  <ProductIcon type={p.icon} size={14} />
                  <span className="truncate uppercase text-[12px]">{p.name}</span>
                </div>
                <div className="text-[#8a8a8a]">{p.category}</div>
                <div className="text-[#e6e6e6]">${Number(p.usdt).toFixed(2)}</div>
                <div className="text-[#e6e6e6]">₹{Number(p.inr).toFixed(2)}</div>
                <div className={`text-right tracking-[0.2em] ${s.color}`}>
                  <span className="text-[#4a4a4a] mr-2">[{String(p.stock || 0).padStart(2, '0')}]</span>{s.label}
                </div>
              </div>
            );
          })}
        </div>
        )}
      </div>
    </div>
  );
};

export default StockStatus;
